import { useState, Fragment, useEffect, useRef } from "react";
import { Delete, Notifications, Restore, Edit } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import {
  CircularProgress,
  Autocomplete,
  Switch,
  TextField,
  Grid2 as Grid,
  IconButton,
} from "@mui/material";
import secureLocalStorage from "react-secure-storage";
import * as XLSX from "xlsx";
import moment from "moment";
import EnhancedTable from "../../components/BTTable";
import BTDialogBox from "../../components/BTDialgBox";
import BTInput from "../../components/BTInput";
import BTButton from "../../components/BTButton";
import authService from "../../services/auth-service";
import BTBox from "../../components/BTBox";
import { useNotification } from "../../context";
import { useLoading } from "../../context";
import BTLoader from "../../components/BTLoader";
import BTTypography from "../../components/BTTypography";
import { batchUpdate } from "../../store/labSlice";
import JsBarcode from "jsbarcode";
import jsPDF from "jspdf";
const filterOptions = [
  { value: "all", label: "All" },
  { value: "verified", label: "Verified" },
  { value: "unverified", label: "Unverified" },
];
const Addstones = ({ setOpen, open, parties, services, sizes, type }) => {
  const { u_id, admin_u_id, u_type } = secureLocalStorage.getItem("userdata");
  const { addNotification } = useNotification();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const { value, actionType } = open;
  const initialformData = {
    p_id: null,
    stn_date: moment().format("YYYY-MM-DD"),
    stn_cts: null,
    stn_pcs: null,
    stn_cus_ref_no: null,
    stn_services: null,
    stn_desc: null,
    stn_type: 1,
    admin_u_id: u_type === 1 ? u_id : admin_u_id,
    stn_created_by: u_id,
    stn_status: 1,
    stn_updated_by: u_id,
    stn_submits: [],
  };

  const initialSubmitRecord = {
    p_id: null,
    stn_date: moment().format("YYYY-MM-DD"),
    stn_cts: null,
    stn_pcs: null,
    stn_cus_ref_no: null,
    stn_services: [],
    stn_desc: null,
    stn_type: 2,
    stn_status: 1,
    admin_u_id: u_type === 1 ? u_id : admin_u_id,
    stn_created_by: u_id,
    stn_updated_by: u_id,
    error_msg: null,
    verify: true,
  };
  const [formData, setFormData] = useState(
    actionType === 1 ? initialformData : value
  );
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(filterOptions[0]);
  const [editingRowId, setEditingRowId] = useState([]);
  const { showLoading, hideLoading } = useLoading();

  const sub_count =
    formData?.stn_submits?.reduce(
      (total, item) => total + (Number(item?.stn_pcs) || 0),
      0
    ) || 0;
  const sub_weight =
    formData?.stn_submits?.reduce(
      (total, item) => total + (Number(item?.stn_cts) || 0),
      0
    ) || 0;

  const validateField = (name, value, row = null) => {
    const newErrors = { ...errors };

    // Helper function to get the error key
    const getErrorKey = (row) => {
      if (!row) return name;
      // Find index for the row to match validateForm's behavior
      const index = formData.stn_submits.findIndex((s) => s === row);
      return index !== -1
        ? `submit_${index}`
        : `submit_${row.stn_id || row.tempId}`;
    };

    const errorKey = getErrorKey(row);

    // Helper functions remain the same
    const setError = (fieldName, message) => {
      if (row) {
        newErrors[errorKey] = {
          ...newErrors[errorKey],
          [fieldName]: message,
        };
      } else {
        newErrors[fieldName] = message;
      }
    };

    const clearError = (fieldName) => {
      if (row) {
        if (newErrors[errorKey]?.[fieldName]) {
          delete newErrors[errorKey][fieldName];
          if (Object.keys(newErrors[errorKey]).length === 0) {
            delete newErrors[errorKey];
          }
        }
      } else if (newErrors[fieldName]) {
        delete newErrors[fieldName];
      }
    };

    switch (name) {
      case "stn_cus_ref_no":
        if (!value || value.trim() === "") {
          setError(name, "Customer Ref No is required");
        }
        // else {
        //   // Check for duplicates
        //   const existingInDatabase = submissions?.some(
        //     (item) =>
        //       item.p_id === formData.p_id &&
        //       item.stn_cus_ref_no === value &&
        //       (actionType === 1 || (row && item.stn_id !== row.stn_id))
        //   );

        //   const existingInForm = formData.stn_submits.some(
        //     (s) => s !== row && s.stn_cus_ref_no === value
        //   );

        //   if (existingInDatabase || existingInForm) {
        //     setError(
        //       name,
        //       "This reference number already exists for this party"
        //     );
        //   }
        //   else {
        //     clearError(name);
        //   }
        // }
        break;

      case "stn_cts":
        if (value === null || value === "") {
          setError(name, "Weight is required");
        } else if (isNaN(value) || parseFloat(value) <= 0) {
          setError(name, "Weight must be a positive number");
        } else {
          clearError(name);
        }
        break;

      case "stn_pcs":
        if (value === null || value === "") {
          setError(name, "Stones count is required");
        } else if (isNaN(value) || parseInt(value) <= 0) {
          setError(name, "Must be a positive integer");
        } else {
          clearError(name);
        }
        break;

      case "stn_services":
        if (!value || value.length === 0) {
          setError(name, "At least one service is required");
        } else {
          clearError(name);
        }
        break;

      case "p_id":
        if (!value) {
          setError(name, "Party is required");
        } else {
          clearError(name);
        }
        break;

      case "stn_date":
        if (!value) {
          setError(name, "Date is required");
        } else {
          clearError(name);
        }
        break;

      default:
        break;
    }

    setErrors(newErrors);
    return newErrors;
  };
  const validateForm = () => {
    const newErrors = {};
    let hasErrors = false;

    // Validate top-level fields
    if (!formData?.p_id) {
      newErrors.p_id = "Party is required";
      hasErrors = true;
    }

    // Validate each submit row using the same logic as validateField
    formData.stn_submits.forEach((submit, index) => {
      const rowErrors = {};

      // Customer Ref No validation
      if (!submit.stn_cus_ref_no || submit.stn_cus_ref_no.trim() === "") {
        rowErrors.stn_cus_ref_no = "Customer Ref No is required";
      }
      // else {
      //   // Duplicate check
      //   const existingInDatabase = submissions?.some(
      //     (item) =>
      //       item.p_id === formData.p_id &&
      //       item.stn_cus_ref_no === submit.stn_cus_ref_no &&
      //       (actionType === 1 || item.stn_id !== submit.stn_id)
      //   );

      //   const existingInForm = formData.stn_submits.some(
      //     (s, i) => i !== index && s.stn_cus_ref_no === submit.stn_cus_ref_no
      //   );

      //   if (existingInDatabase || existingInForm) {
      //     rowErrors.stn_cus_ref_no =
      //       "This reference number already exists for this party";
      //   }
      // }

      // Weight validation
      if (submit.stn_cts === null || submit.stn_cts === "") {
        rowErrors.stn_cts = "Weight is required";
      } else if (isNaN(submit.stn_cts) || parseFloat(submit.stn_cts) <= 0) {
        rowErrors.stn_cts = "Weight must be a positive number";
      }

      // Stones count validation
      if (submit.stn_pcs === null || submit.stn_pcs === "") {
        rowErrors.stn_pcs = "Stones count is required";
      } else if (isNaN(submit.stn_pcs) || parseInt(submit.stn_pcs) <= 0) {
        rowErrors.stn_pcs = "Must be a positive integer";
      }

      // Services validation
      if (!submit.stn_services || submit.stn_services.length === 0) {
        rowErrors.stn_services = "At least one service is required";
      }

      if (Object.keys(rowErrors).length > 0) {
        newErrors[`submit_${index}`] = rowErrors;
        hasErrors = true;
      }
    });

    setErrors(newErrors);
    return hasErrors ? newErrors : {};
  };

  const handleClose = () => {
    setOpen(null);
  };
  const handleUpload = () => {
    fileInputRef.current.click();
  };
  const submitStones = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
      if (formData?.stn_submits?.length === 0) {
        return addNotification({
          icon: <Notifications color="white" />,
          title: "Error!",
          message: "Please enter at least one stone submission.",
          color: "error",
        });
      }
      const finalFormData = {
        ...formData,
        stn_pcs: sub_count,
        stn_cts: sub_weight,
      };

      const deleteRec = formData?.stn_submits?.filter(
        ({ stn_deleted }) => stn_deleted
      );
      try {
        setLoading(true);
        const isNewrecord = actionType === 1 ? true : false;
        const response = isNewrecord
          ? await authService?.insert_submission({
              attributes: { ...finalFormData, final_submit: true },
            })
          : await authService?.update_submission({
              attributes: { ...finalFormData, final_submit: true },
            });

        if (response?.status && response?.status_code === 200) {
          const { stn_submits, ...data } = response?.data;
          const updateRec = type ? stn_submits : [data];
          dispatch(
            batchUpdate({
              name: "submission",
              key: "stn_id",
              insert: actionType === 1 ? updateRec : [],
              updateItems: actionType === 2 ? updateRec : [],
              removeItems: deleteRec,
            })
          );
          addNotification({
            icon: <Notifications color="white" />,
            title: "Success!",
            message: response?.message,
            color: "success",
          });
          handleClose();
        } else {
          const { submits } = response?.data;
          setFormData((prev) => ({
            ...prev,
            stn_submits: submits,
          }));
          addNotification({
            icon: <Notifications color="white" />,
            title: "Error!",
            message: response?.message,
            color: "error",
          });
          return;
        }
        // if (response?.status_code === 206) {
        //   const { submits } = response?.data;
        //   setFormData((prev) => ({
        //     ...prev,
        //     stn_submits: submits,
        //   }));
        //   addNotification({
        //     icon: <Notifications color="white" />,
        //     title: "Error!",
        //     message: response?.message,
        //     color: "error",
        //   });
        //   return;
        // } else {
        //   const { stn_submits, ...data } = response?.data;
        //   // manage_store_data({
        //   //   name: "submissions",
        //   //   data: [data, ...stn_submits],
        //   //   type: "update",
        //   //   key: "stn_id",
        //   //   total:
        //   //     actionType === 2
        //   //       ? total
        //   //       : type === 1
        //   //       ? total + 1
        //   //       : total + stn_submits?.length,
        //   // });
        //   addNotification({
        //     icon: <Notifications color="white" />,
        //     title: "Success!",
        //     message: response?.message,
        //     color: "success",
        //   });
        //   setRefresh((prev) => !prev);
        //   handleClose();
        // }
      } catch (error) {
        addNotification({
          icon: <Notifications color="white" />,
          title: "Error!",
          message: error?.response?.data?.message || "Something went wrong",
          color: "error",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleformDataChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    validateField(name, value);
  };

  const handleAutocompleteChange = (name, value, row) => {
    if (name === "stn_services") {
      const modifiedValue = value?.map(({ value, label }) => ({
        ser_id: value,
        ser_name: label,
      }));

      setFormData((prev) => {
        const updatedSubmits = prev.stn_submits.map((submit) =>
          submit === row
            ? {
                ...submit,
                [name]: modifiedValue,
              }
            : submit
        );
        return {
          ...prev,
          stn_submits: updatedSubmits,
        };
      });
      validateField(name, modifiedValue, row);
    } else {
      const fieldValue = value?.value || null;
      setFormData((prev) => ({
        ...prev,
        [name]: fieldValue,
        stn_submits: prev?.stn_submits?.map((item) => ({
          ...item,
          error_msg: null,
          verify: true,
        })),
      }));
      validateField(name, fieldValue);
    }
  };
  const handleFilterChange = (event, newValue) => {
    setFilter(newValue);
  };

  const handleServiceToggle = (row, name) => {
    setFormData((prev) => {
      const updatedSubmits = prev.stn_submits.map((submit) => {
        if (submit === row) {
          const currentValue = submit[name];
          const newValue = currentValue === 1 ? null : 1;
          return {
            ...submit,
            [name]: newValue,
          };
        }
        return submit;
      });

      return {
        ...prev,
        stn_submits: updatedSubmits,
      };
    });
  };

  const handleTableFieldChange = (name, value, row) => {
    setFormData((prev) => {
      const updatedSubmits = prev.stn_submits.map((submit) => {
        if (submit === row) {
          const updatedRow = {
            ...submit,
            [name]: value,
          };
          if (name === "stn_cts") {
            const weight = parseFloat(value) || 0;
            const matchingSize = sizes?.find(
              ({ size_from, size_to }) =>
                weight >= size_from && weight <= size_to
            );
            updatedRow.size_id = matchingSize?.size_id || null;
          }
          return updatedRow;
        }
        return submit;
      });

      return {
        ...prev,
        stn_submits: updatedSubmits,
      };
    });

    validateField(name, value, row);
  };
  const addSubmitRecord = () => {
    if (!formData.p_id) return;
    setFormData((prev) => ({
      ...prev,
      stn_submits: [
        {
          ...initialSubmitRecord,
          p_id: prev.p_id,
          stn_date: prev.stn_date,
        },
        ...prev.stn_submits,
      ],
    }));
  };

  const removeSubmitRecord = (refNoOrRefNos) => {
    const refNosToRemove = Array.isArray(refNoOrRefNos)
      ? refNoOrRefNos
      : [refNoOrRefNos];
    if (actionType === 2 && refNosToRemove?.some((item) => item?.stn_id)) {
      setFormData((prev) => ({
        ...prev,
        stn_submits: prev?.stn_submits?.map((item) => {
          if (refNosToRemove.includes(item)) {
            return { ...item, stn_deleted: item?.stn_deleted === 1 ? 0 : 1 };
          }
          return item;
        }),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        stn_submits: prev.stn_submits.filter(
          (item) => !refNosToRemove.includes(item)
        ),
      }));
    }
  };

  const renderField = (field, record, onChange, error, row) => {
    switch (field.type) {
      case "select":
        return (
          <Autocomplete
            multiple={field?.multiple || false}
            limitTags={2}
            options={field.options}
            value={
              field.multiple
                ? field.options.filter((opt) =>
                    record[field.name]?.some(
                      ({ ser_id }) => ser_id === opt?.value
                    )
                  )
                : field?.options?.find(
                    (opt) => opt.value === record[field.name]
                  ) || null
            }
            onChange={(_, value) =>
              handleAutocompleteChange(field.name, value, row)
            }
            sx={{
              "& .MuiAutocomplete-tag": {
                height: "20px",
                fontSize: "12px",
              },
            }}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField
                {...params}
                label={field.label}
                variant="standard"
                fullWidth
                error={!!error}
                helperText={error}
                required={field.required}
              />
            )}
          />
        );
      default:
        return (
          <BTInput
            name={field.name}
            label={field.label}
            type={field.type || "text"}
            value={record[field.name] || ""}
            onChange={onChange}
            variant="standard"
            required={field.required}
            fullWidth
            error={!!error}
            helperText={error}
            {...field.props}
          />
        );
    }
  };

  const handleFileChange = async (e) => {
    const selectedFiles = Array.from(e.target.files);
    if (!selectedFiles.length) return;
    try {
      showLoading();
      let submitsData = [];
      // Process each file sequentially
      for (const selectedFile of selectedFiles) {
        const fileResult = await processSingleFile(selectedFile, services);
        submitsData = [...submitsData, ...fileResult];
      }
      const obj = {
        ...formData,
        stn_submits: submitsData,
        final_submit: false,
      };
      try {
        const response = await authService?.insert_submission({
          attributes: obj,
        });
        const isError = response?.status_code === 206;
        const { submits } = response?.data || [];
        setFormData((prev) => ({
          ...prev,
          stn_submits: [...(prev.stn_submits || []), ...submits],
        }));
        addNotification({
          icon: <Notifications color="white" />,
          title: isError ? "Error!" : "Successfully!",
          message: response?.message,
          color: isError ? "warning" : "success",
        });
      } catch (error) {
        addNotification({
          icon: <Notifications color="white" />,
          title: "Error!",
          message: error?.response?.data?.message || "Something went wrong",
          color: "error",
        });
      }
    } catch (error) {
      addNotification({
        icon: <Notifications color="white" />,
        title: "Error!",
        message: error.message.includes("Invalid file format")
          ? "Invalid file format. Please upload valid Excel or CSV files."
          : "Error processing files",
        color: "error",
      });
    } finally {
      hideLoading();
    }
  };
  // Helper function to process individual file
  const processSingleFile = (file, services) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, {
            type: file.name.endsWith(".csv") ? "string" : "binary",
          });
          const firstSheet = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheet];
          const jsonResult = XLSX.utils.sheet_to_json(worksheet, {
            defval: "",
          });

          const availableServices = createServicesMap(services);
          const FDR_SERVICE = availableServices?.[2];
          const DOSSIER_SERVICE = availableServices?.[3];

          const submitItems = jsonResult
            .filter((item) => String(item["Customer Ref No."])?.trim())
            .map((item) =>
              processItem(item, availableServices, FDR_SERVICE, DOSSIER_SERVICE)
            );
          resolve(submitItems);
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = () => {
        reject(new Error("Error reading file"));
      };

      if (file.name.endsWith(".csv")) {
        reader.readAsText(file);
      } else {
        reader.readAsBinaryString(file);
      }
    });
  };

  // Helper functions
  const createServicesMap = (services) => {
    return services?.reduce((acc, service) => {
      acc[service.ser_id] = {
        ser_id: service.ser_id,
        ser_name: service.ser_name,
        ser_time: service.ser_time,
        ser_price_type: service.ser_price_type,
      };
      return acc;
    }, {});
  };

  const normalizeServiceName = (name) => {
    return name?.replace(/\s+/g, "").toLowerCase();
  };

  const processItem = (
    item,
    availableServices,
    FDR_SERVICE,
    DOSSIER_SERVICE
  ) => {
    const submitItem = {
      p_id: formData?.p_id,
      stn_date: formData?.stn_date,
      stn_cts: item.Weight,
      stn_pcs: item["Number Stones"],
      stn_cus_ref_no: String(item["Customer Ref No."]).trim(),
      stn_services: [],
      stn_without_plot: null,
      stn_tatkal: null,
      stn_color: null,
      size_id: null,
      stn_desc: item["Description"] || "",
      admin_u_id: u_type === 1 ? u_id : admin_u_id,
      stn_created_by: u_id,
      stn_updated_by: u_id,
      stn_status: 1,
      stn_type: 2,
      verify: true,
      error_msg: "Ok",
    };

    const serviceNames = item.SERVICES?.trim()
      ? item.SERVICES.split(",").map((s) => normalizeServiceName(s.trim()))
      : [];

    const additionalServices = item["Additional Services"]?.trim()
      ? item["Additional Services"]
          .split(",")
          .map((s) => normalizeServiceName(s.trim()))
      : [];

    // Define special services with normalized names
    const SPECIAL_SERVICES = {
      withoutplotting: "withoutplotting", // Keep as 'plotting' without changing to 'without_plot'
      tatkal: "tatkal",
      color: "color",
    };
    // size_id,
    const size = sizes?.find(
      ({ size_from, size_to }) =>
        item.Weight >= size_from && item.Weight <= size_to
    );
    submitItem.size_id = size?.size_id;

    // Process special services
    const specialServicesHandlers = {
      [SPECIAL_SERVICES.withoutplotting]: () =>
        (submitItem.stn_without_plot = 1),
      [SPECIAL_SERVICES.tatkal]: () => (submitItem.stn_tatkal = 1),
      [SPECIAL_SERVICES.color]: () => (submitItem.stn_color = 1),
    };

    // Track if we found any regular services
    let hasRegularServices = false;

    if (serviceNames.length > 0) {
      serviceNames.forEach((serviceName) => {
        const service = findServiceByName(availableServices, serviceName);
        // Handle special services
        if (specialServicesHandlers[serviceName]) {
          specialServicesHandlers[serviceName]();
        } else if (service && submitItem?.stn_services) {
          const serviceExists = submitItem.stn_services.some(
            (s) => s?.ser_id === service?.ser_id
          );

          if (!serviceExists) {
            if (serviceName === "recutdossier" || serviceName === "recutfdr") {
              submitItem.stn_status = 5; // Consider creating a new object instead of direct mutation
            }
            if (
              serviceName === "certyrecheckcolor" ||
              serviceName === "certyrecheckclarity" ||
              serviceName === "certyrecheckcut" ||
              serviceName === "certyrecheckpolish" ||
              serviceName === "certyrechecksym"
            ) {
              submitItem.stn_status = 10;
            }
            const newService = createServiceObject(service);
            if (newService) {
              submitItem.stn_services = [
                ...submitItem.stn_services,
                newService,
              ]; // Immutable update
              if (![17, 30].includes(newService?.ser_id)) {
                // if "H & A" or "H & A RED" as service, do not count as regular service
                hasRegularServices = true;
              }
            }
          }
        } else {
          submitItem.verify = false;
          submitItem.error_msg = `${serviceName} service is not available`;
        }
      });
    }
    if (additionalServices.length > 0) {
      additionalServices?.forEach((serviName) => {
        if (specialServicesHandlers[serviName]) {
          specialServicesHandlers[serviName]();
        } else {
          submitItem.verify = false;
          submitItem.error_msg = `${serviName} additional service is not available`;
        }
      });
    }
    // Add weight-based services only if:
    // 1. No regular services were added, AND
    // 2. Services were empty OR only special services were specified

    const shouldAddWeightBasedServices =
      !hasRegularServices &&
      (serviceNames.length === 0 ||
        serviceNames.every((name) =>
          Object.values(SPECIAL_SERVICES).includes(name)
        ) ||
        !Object?.values(availableServices)?.every((item) =>
          serviceNames?.includes(
            item?.ser_name?.replace(/\s+/g, "").toLowerCase()
          )
        ));

    if (shouldAddWeightBasedServices) {
      const weight = parseFloat(item.Weight) || 0;
      const weightBasedService = weight < 1 ? DOSSIER_SERVICE : FDR_SERVICE;

      if (weightBasedService) {
        submitItem.stn_services.push(createServiceObject(weightBasedService));
      }
    }
    return submitItem;
  };

  const findServiceByName = (availableServices, serviceName) => {
    if (!availableServices) return null;

    const normalizedSearchName = normalizeServiceName(serviceName);

    return Object.values(availableServices).find(
      (s) => normalizeServiceName(s.ser_name) === normalizedSearchName
    );
  };

  const createServiceObject = (service) => ({
    ser_id: service.ser_id,
    ser_name: service.ser_name,
    ser_time: service.ser_time,
    ser_price_type: service.ser_price_type,
    ser_date: formData?.stn_date,
    res_date: null,
    rep_date: null,
    ser_status: null,
  });

  const handleEditClick = (row, index) => {
    const rowId = row?.stn_id || index;
    if (editingRowId.includes(rowId)) {
      setEditingRowId(editingRowId.filter((id) => id !== rowId));
    } else {
      setEditingRowId([...editingRowId, rowId]);
    }
  };

  const generateBarcodePdf = async () => {
    let items = formData.stn_submits?.map(
      ({ stn_prefix_ref_no, stn_cts, stn_pcs }) => ({
        reff: stn_prefix_ref_no || "No Reff Code",
        wt: stn_cts,
        pcs: stn_pcs,
      })
    );

    try {
      // config (change these)
      const W = 50;
      const H = 25;
      const M = { top: 2, left: 2, right: 2, bottom: 2 };
      const BAR_W = 600;
      const BAR_H = 130;

      const doc = new jsPDF({
        unit: "mm",
        format: [W, H],
        orientation: W >= H ? "l" : "p",
      });
      const usableW = W - (M.left + M.right);
      const usableH = H - (M.top + M.bottom);
      const canvas = document.createElement("canvas");
      canvas.width = BAR_W;
      canvas.height = BAR_H;
      const ctx = canvas.getContext("2d");

      let first = true;
      for (const it of items) {
        // draw barcode into single canvas
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        JsBarcode(canvas, String(it.reff), {
          format: "CODE128",
          width: 2,
          height: Math.floor(BAR_H * 0.6),
          displayValue: false,
          margin: 4,
        });
        const dataUrl = canvas.toDataURL("image/png");

        if (!first) doc.addPage([W, H], W >= H ? "l" : "p");
        first = false;

        // load image to get natural size -> compute mm dims preserving aspect ratio
        const img = new Image();
        img.src = dataUrl;
        await new Promise((res) => {
          img.onload = res;
          img.onerror = res;
        });

        let drawW = usableW;
        let drawH = (img.naturalHeight * drawW) / img.naturalWidth;
        const barAreaH = usableH * 0.55;
        if (drawH > barAreaH) {
          drawH = barAreaH;
          drawW = (img.naturalWidth * drawH) / img.naturalHeight;
        }

        const x = M.left + Math.max((usableW - drawW) / 2, 0);
        const y = M.top + Math.max((barAreaH - drawH) / 2, 0);
        doc.addImage(dataUrl, "PNG", x, y, drawW, drawH);

        // vector text below barcode
        const cx = W / 2;
        const textY = M.top + barAreaH + 3.5;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text(`${it.reff}`, cx, textY, { align: "center" });
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text(
          `Wt: ${Number(it.wt).toFixed(2)} | Pcs: ${it.pcs}`,
          cx,
          textY + 5,
          { align: "center" }
        );
      }
      doc.save("barcodes.pdf");
      doc.output("dataurlnewwindow");
    } catch (e) {
   
    }
  };

  const generateRefPdf = async () => {
    const rows = (formData.stn_submits || []).map(
      ({ stn_cus_ref_no, stn_prefix_ref_no, stn_cts, stn_pcs }) => ({
        stn_cus_ref_no,
        stn_prefix_ref_no,
        stn_cts,
        stn_pcs,
      })
    );
    const partyName =
      parties?.find((s) => s.p_id === formData?.p_id)?.p_name || "Party Name";
    const totalPcs = rows.reduce((sum, r) => sum + (Number(r.stn_pcs) || 0), 0);
    const totalCts = rows.reduce((sum, r) => sum + (Number(r.stn_cts) || 0), 0);

    const doc = new jsPDF("p", "mm", "a4");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const pageMargin = 12;
    const headerHeight = 10;
    const footerHeight = 10;
    const minRowHeight = 8;
    const textLineHeight = 4.6;

    const tableWidth = pageWidth - pageMargin * 2;
    const tableTopY = pageMargin + headerHeight + 4;

    // fixed column widths, remarks auto-calculated
    const fixedColumns = [
      { key: "stn_cus_ref_no", label: "Customer Ref No", width: 48 },
      { key: "stn_prefix_ref_no", label: "Prefix No", width: 40 },
      { key: "stn_pcs", label: "PCS", width: 18 },
      { key: "stn_cts", label: "CTS", width: 22 },
      // { key: "shape", label: "Shape", width: 22 },
    ];

    const usedWidth = fixedColumns.reduce((s, c) => s + c.width, 0);
    const remarksWidth = Math.max(tableWidth - usedWidth, 30);

    const columns = [
      ...fixedColumns,
      { key: "remarks", label: "Remarks", width: remarksWidth },
    ];

    let cursorY = pageMargin;
    let currentPage = 1;
    const maxTableY = pageHeight - pageMargin - footerHeight;

    doc.setFont("helvetica", "bold").setFontSize(13);
    doc.text(
      `${partyName}  |  Total PCS: ${totalPcs}  |  Total CTS: ${totalCts.toFixed(
        2
      )}`,
      pageWidth / 2,
      cursorY,
      { align: "center" }
    );

    cursorY += headerHeight + 2;

    const addPageFooter = (pageNumber) => {
      doc.setFont("helvetica", "normal").setFontSize(9);
      doc.text(
        `Page ${pageNumber}`,
        pageWidth - pageMargin,
        pageHeight - pageMargin + 2,
        { align: "right" }
      );
    };

    const drawTableHeader = (yPosition) => {
      doc.setFillColor(245);
      doc.rect(pageMargin, yPosition, tableWidth, minRowHeight, "F");

      let xPos = pageMargin;
      doc.setFont("helvetica", "bold").setFontSize(11);

      for (const col of columns) {
        doc.text(col.label, xPos + 2, yPosition + minRowHeight - 1);
        doc.rect(xPos, yPosition, col.width, minRowHeight);
        xPos += col.width;
      }
      doc.setFont("helvetica", "normal").setFontSize(10);
      return yPosition + minRowHeight;
    };

    cursorY = drawTableHeader(cursorY);

    doc.setFont("helvetica", "normal").setFontSize(10);

    for (const row of rows) {
      let cellDataList = [];

      let colX = pageMargin;
      for (const col of columns) {
        const text = String(row[col.key] ?? "");
        const textMaxWidth = col.width - 4;
        const wrappedLines = doc.splitTextToSize(text, textMaxWidth);

        cellDataList.push({ lines: wrappedLines, x: colX, width: col.width });
        colX += col.width;
      }

      const maxLinesInRow = Math.max(
        ...cellDataList.map((cd) => cd.lines.length)
      );
      const rowHeight = Math.max(
        minRowHeight,
        Math.ceil(maxLinesInRow * textLineHeight)
      );

      if (cursorY + rowHeight > maxTableY) {
        addPageFooter(currentPage);
        doc.addPage();
        currentPage++;
        doc.setFont("helvetica", "normal").setFontSize(10);
        cursorY = pageMargin;
        cursorY = drawTableHeader(cursorY);
      }

      for (const cell of cellDataList) {
        const startY = cursorY + 5;
        cell.lines.forEach((line, idx) => {
          const textY = startY + idx * textLineHeight;
          doc.text(line, cell.x + 2, textY);
        });
        doc.rect(cell.x, cursorY, cell.width, rowHeight);
      }

      cursorY += rowHeight;
    }

    addPageFooter(currentPage);

    const tableBottomY = Math.min(cursorY, maxTableY);

    doc.setDrawColor(120);
    doc.setLineWidth(0.4);
    // doc.rect(
    //   pageMargin - 0.5,
    //   tableTopY - 0.5,
    //   tableWidth + 1,
    //   tableBottomY - tableTopY + 0.5
    // );

    doc.output("dataurlnewwindow");
  };

  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "stn_prefix_ref_no",
      name: "Prefix No",
      selector: (row) => row?.stn_prefix_ref_no,
      width: "100px",
      sortable: true,
    },
    {
      id: "stn_cus_ref_no",
      name: "Customer Ref No",
      selector: (row, index) => {
        const isEditing = editingRowId.includes(row?.stn_id || index);
        const error = errors[`submit_${index}`]?.stn_cus_ref_no;
        return isEditing ? (
          <TextField
            value={row.stn_cus_ref_no || ""}
            onChange={(e) =>
              handleTableFieldChange("stn_cus_ref_no", e.target.value, row)
            }
            size="small"
            sx={{
              position: "relative",
              top: "7px",
            }}
            fullWidth
            error={!!error}
            helperText={error}
            variant="standard"
          />
        ) : (
          row.stn_cus_ref_no
        );
      },
      value: (row) => row?.stn_cus_ref_no,
      width: "200px",
    },
    {
      id: "stn_date",
      name: "Date",
      selector: (row) =>
        moment(row?.stn_date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      sortable: true,
    },
    {
      id: "stn_pcs",
      name: "Pcs",
      selector: (row, index) => {
        const isEditing = editingRowId.includes(row?.stn_id || index);
        const error = errors[`submit_${index}`]?.stn_pcs;
        return isEditing ? (
          <TextField
            type="number"
            value={row.stn_pcs || ""}
            onChange={(e) =>
              handleTableFieldChange("stn_pcs", e.target.value, row)
            }
            sx={{
              position: "relative",
              top: "7px",
            }}
            size="small"
            fullWidth
            variant="standard"
            error={!!error}
            helperText={error}
          />
        ) : (
          row.stn_pcs
        );
      },
      value: (row) => row?.stn_pcs,
      width: "100px",
    },
    {
      id: "stn_cts",
      name: "Weight",
      selector: (row, index) => {
        const isEditing = editingRowId.includes(row?.stn_id || index);
        const error = errors[`submit_${index}`]?.stn_cts;
        return isEditing ? (
          <TextField
            type="number"
            value={row.stn_cts || ""}
            onChange={(e) =>
              handleTableFieldChange("stn_cts", e.target.value, row)
            }
            sx={{
              position: "relative",
              top: "7px",
            }}
            size="small"
            fullWidth
            variant="standard"
            error={!!error}
            helperText={error}
          />
        ) : (
          row.stn_cts
        );
      },
      value: (row) => row?.stn_cts,
      width: "100px",
    },
    {
      id: "size_id",
      name: "Size",
      selector: (row) => {
        const size = sizes?.find(({ size_id }) => size_id === row?.size_id);
        return size ? `${size?.size_from} - ${size?.size_to}` : "-";
      },
      width: "100px",
    },
    {
      id: "stn_services",
      name: "Services",
      selector: (row, index) => {
        const isEditing = editingRowId.includes(row?.stn_id || index);
        const error = errors[`submit_${index}`]?.stn_services;
        return isEditing ? (
          <Autocomplete
            multiple
            disableClearable
            options={
              services?.map(
                ({ ser_id, ser_name, ser_time, ser_price_type }) => ({
                  value: ser_id,
                  label: ser_name,
                  ser_time,
                  ser_price_type: ser_price_type,
                })
              ) || []
            }
            value={
              row.stn_services?.map((service) => ({
                value: service.ser_id,
                label: service.ser_name,
                ser_time: service.ser_time,
                ser_price_type: service.ser_price_type,
              })) || []
            }
            onChange={(_, newValue) => {
              const modifiedValue = newValue.map(
                ({ value, label, ser_time, ser_price_type }) => ({
                  ser_id: value,
                  ser_name: label,
                  ser_time,
                  ser_date: formData?.stn_date,
                  res_date: null,
                  rep_date: null,
                  ser_price_type,
                  ser_status: null,
                })
              );
              handleTableFieldChange("stn_services", modifiedValue, row);
            }}
            size="small"
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                sx={{
                  position: "relative",
                  top: "4px",
                }}
                fullWidth
                error={!!error}
                helperText={error}
              />
            )}
            sx={{ minWidth: 150 }}
          />
        ) : (
          row.stn_services?.map((s) => s.ser_name).join(", ")
        );
      },
      value: (row) => row?.stn_services?.map((s) => s.ser_name).join(", "),
      bodyCellStyle: {
        padding: "0px",
      },
      width: "200px",
    },
    {
      id: "without plotting",
      name: "Without plotting",
      selector: (row, index) => {
        const isChecked = row?.stn_without_plot;
        const isDisabled =
          row?.stn_services?.some(
            (service) =>
              service.ser_name?.toLowerCase() === "dossier" ||
              service?.ser_name?.toLowerCase() === "fdr"
          ) && [1, 5].includes(row?.stn_status);

        return (
          <Switch
            size="small"
            checked={Boolean(isChecked)}
            onChange={() => handleServiceToggle(row, "stn_without_plot")}
            color="secondary"
            disabled={!isDisabled}
          />
        );
      },
      value: (row) => (row?.stn_without_plot ? "Yes" : "No"),
      bodyCellStyle: {
        padding: "0px",
      },
      width: "100px",
    },
    {
      id: "tatkal",
      name: "Tatkal",
      selector: (row, index) => {
        const isChecked = row?.stn_tatkal;
        const isDisabled =
          row?.stn_services?.some(
            (service) =>
              service.ser_name?.toLowerCase() === "dossier" ||
              service?.ser_name?.toLowerCase() === "fdr"
          ) && [1, 5].includes(row?.stn_status);
        return (
          <Switch
            size="small"
            checked={Boolean(isChecked)}
            color="secondary"
            onChange={() => handleServiceToggle(row, "stn_tatkal")}
            disabled={!isDisabled}
          />
        );
      },
      value: (row) => (row?.stn_tatkal ? "Yes" : "No"),
      width: "100px",
      bodyCellStyle: {
        padding: "0px",
      },
    },
    {
      id: "color",
      name: "Color",
      selector: (row, index) => {
        const isChecked = row?.stn_color;
        const isDisabled =
          row?.stn_services?.some(
            (service) =>
              service.ser_name?.toLowerCase() === "dossier" ||
              service?.ser_name?.toLowerCase() === "fdr"
          ) && [1, 5].includes(row?.stn_status);
        return (
          <Switch
            size="small"
            checked={Boolean(isChecked)}
            color="secondary"
            onChange={() => handleServiceToggle(row, "stn_color")}
            disabled={!isDisabled}
          />
        );
      },
      value: (row) => (row?.stn_color ? "Yes" : "No"),
      bodyCellStyle: {
        padding: "0px",
      },
    },
    {
      id: "stn_desc",
      name: "Description",
      selector: (row, index) => {
        const isEditing = editingRowId.includes(row?.stn_id || index);
        return isEditing ? (
          <TextField
            type="text"
            value={row.stn_desc || ""}
            onChange={(e) =>
              handleTableFieldChange("stn_desc", e.target.value, row)
            }
            sx={{
              position: "relative",
              top: "7px",
            }}
            size="small"
            fullWidth
            variant="standard"
          />
        ) : (
          row.stn_desc
        );
      },
      width: "150px",
      bodyCellStyle: {
        padding: "0px",
      },
    },
    {
      id: "status",
      name: "status",
      selector: (row) => row?.error_msg || "Ok",
    },
    {
      id: "actions",
      name: "Actions",
      selector: (row, index) =>
        [1, 5, 10].includes(row?.stn_status) ? (
          <BTBox>
            <IconButton
              onClick={() => handleEditClick(row, index)}
              size="small">
              <Edit fontSize="12px" color="success" />
            </IconButton>
            {actionType === 1 && (
              <IconButton onClick={() => removeSubmitRecord(row)} size="small">
                {row?.stn_deleted === 1 ? (
                  <Restore color="success" fontSize="12px" />
                ) : (
                  <Delete fontSize="12px" color="error" />
                )}
              </IconButton>
            )}
          </BTBox>
        ) : null,
      bodyCellStyle: {
        padding: "0px",
      },
      center: true,
      width: "100px",
    },
  ];
  const sharedFieldsConfig = [
    {
      name: "p_id",
      label: "Party",
      type: "select",
      options:
        parties?.map(({ p_id, p_name, p_code }) => ({
          value: p_id,
          label: `${p_code} : ${p_name}`,
        })) || [],
      required: true,
      gridSize: { xs: 12, md: 3 },
    },
    {
      name: "stn_date",
      label: "Date",
      type: "date",
      required: true,
      gridSize: { xs: 12, md: 2 },
    },
    {
      name: "stn_desc",
      label: "Description",
      type: "text",
      required: false,
      gridSize: { xs: 12, md: 3 },
    },
  ];

  useEffect(() => {
    if (formData.stn_submits.length > 0) {
      setFormData((prev) => ({
        ...prev,
        stn_submits: prev.stn_submits.map((submit) => ({
          ...submit,
          p_id: prev.p_id,
          stn_date: prev.stn_date,
          stn_services: submit?.stn_services?.map((ser) => ({
            ...ser,
            ser_date: prev.stn_date,
          })),
        })),
      }));
    }
  }, [formData.p_id, formData.stn_date]);
  const getFilteredSubmits = () => {
    switch (filter.value) {
      case "verified":
        return formData.stn_submits.filter((submit) => submit.verify === true);
      case "unverified":
        return formData.stn_submits.filter((submit) => submit.verify === false);
      default:
        return formData.stn_submits;
    }
  };

  return (
    <BTDialogBox
      open={Boolean(open)}
      fullWidth
      maxWidth={false}
      maxHeight={"700px"}
      minHeight={"700px"}
      onSubmit={submitStones}
      close={handleClose}
      title={actionType === 1 ? "Add stones" : "Edit stones"}
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: actionType === 1 ? "Submit" : "Update",
          variant: "gradient",
          type: "submit",
          color: "dark",
          size: "small",
          disabled:
            loading ||
            formData.stn_submits.length === 0 ||
            (actionType !== 2 &&
              formData?.stn_submits?.some((item) => !item.verify)),
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          sx: { ml: 2, width: "80px" },
        },
      ]}>
      <BTLoader />

      <Grid container spacing={2} position={"relative"} alignItems={"center"}>
        {sharedFieldsConfig.map((field, index) => (
          <Grid size={field?.gridSize} key={`main-${index}`}>
            {renderField(
              field,
              formData,
              handleformDataChange,
              errors[field.name]
            )}
          </Grid>
        ))}
        <Grid size={{ xs: 12, md: 2 }}>
          <Autocomplete
            options={filterOptions}
            getOptionLabel={(option) => option.label}
            disableClearable
            value={filter}
            onChange={handleFilterChange}
            renderInput={(params) => (
              <TextField {...params} label="Filter" variant="standard" />
            )}
          />
        </Grid>
        <Grid
          size={{ xs: 12, md: 2 }}
          display="flex"
          gap={1}
          alignItems="center">
          <BTButton
            variant="gradient"
            onClick={addSubmitRecord}
            disabled={!formData.p_id}
            color="dark"
            size="small"
            sx={{ width: "80px" }}
            fullWidth>
            Add
          </BTButton>
          <BTButton
            variant="gradient"
            onClick={handleUpload}
            disabled={!formData.p_id}
            color="dark"
            size="small"
            sx={{ width: "80px" }}
            fullWidth>
            Upload
          </BTButton>
          <BTButton
            variant="gradient"
            onClick={generateRefPdf}
            disabled={!formData.p_id || !formData.stn_id}
            color="dark"
            size="small"
            sx={{ width: "100px" }}
            fullWidth>
            Print
          </BTButton>
          <BTButton
            variant="gradient"
            onClick={generateBarcodePdf}
            disabled={!formData.p_id || !formData.stn_id}
            color="dark"
            size="small"
            sx={{ width: "150px" }}
            fullWidth>
            Barcodes
          </BTButton>
          <input
            type="file"
            multiple={true}
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: "none" }}
            accept=".xlsx,.xls,.csv"
          />
        </Grid>
        <Grid
          size={{ xs: 12, md: 6 }}
          display={"flex"}
          flexDirection={"row"}
          gap={1}
          alignItems={"center"}>
          <BTTypography
            variant="button"
            fontWeight={"text"}
            textTransform={"capitalize"}>
            Total Pcs : {sub_count}
          </BTTypography>
          |
          <BTTypography
            variant="button"
            fontWeight={"text"}
            textTransform={"capitalize"}>
            Total Weight : {sub_weight?.toFixed(2)}
          </BTTypography>
        </Grid>
      </Grid>

      <BTBox mt={1}>
        <EnhancedTable
          rows={getFilteredSubmits()}
          columns={columns}
          checkBoxSelected={true}
          onDeleteSelected={removeSubmitRecord}
          tableHeader={true}
          pagination={true}
          getRowStyle={(row) => {
            if (!row?.verify && row?.verify === false) {
              return {
                backgroundColor: "#fbd1d3",
                "&:hover": {
                  backgroundColor: "#d0e9d1",
                },
              };
            }
          }}
        />
      </BTBox>
    </BTDialogBox>
  );
};

export default Addstones;
